import { editableSectionNames, propertyNames, sectionsToProperties } from './constants'

const RESORT_DISCOVERY_SECTION_PROPERTIES = {
  header: ['logoUrl', 'logoWidth', 'logoHeight'],
  hero: ['heroImgUrl', 'heroImageLinkUrl'],
  body: ['emailTitle', 'bodyHtml', 'ctaText', 'ctaBackgroundColor', 'ctaTextColor'],
  lifestyle: ['lifestyleImage', 'lifestyleImageLinkUrl', 'lifestyleImageAlt'],
  discoverIntro: ['galleryTitle', 'discoverIntroText'],
  discoverButtons: [
    'discoverBtn1',
    'discoverBtn1LinkUrl',
    'discoverBtn2',
    'discoverBtn2LinkUrl',
    'discoverBtn3',
    'discoverBtn3LinkUrl',
    'discoverBtn4',
    'discoverBtn4LinkUrl'
  ],
  gallery: [
    'gallery1Image',
    'gallery1ImageLinkUrl',
    'gallery2Image',
    'gallery2ImageLinkUrl',
    'gallery3Image',
    'gallery3ImageLinkUrl',
    'gallery4Image',
    'gallery4ImageLinkUrl'
  ],
  footer: ['socialMediaLinks', 'hotelPhone', 'hotelWebsite', 'hotelWebsiteUrl', 'finePrintHtml']
}

const EDITORIAL_EVENT_SECTION_PROPERTIES = {
  header: ['logoUrl', 'logoWidth', 'logoHeight', 'headerTaglineScript', 'headerTaglineSans'],
  hero: ['heroImgUrl', 'heroImageLinkUrl'],
  body: ['emailTitle', 'bodyHtml', 'ctaText', 'ctaBackgroundColor', 'ctaTextColor'],
  experiencesIntro: ['featuresSectionTitle'],
  col1: ['col1Image', 'col1ImageLinkUrl', 'col1Html', 'col1LinkText', 'col1LinkUrl'],
  col2: ['col2Image', 'col2ImageLinkUrl', 'col2Html', 'col2LinkText', 'col2LinkUrl'],
  col3: ['col3Image', 'col3ImageLinkUrl', 'col3Html', 'col3LinkText', 'col3LinkUrl'],
  footer: ['socialMediaLinks', 'footerAccentColor', 'finePrintHtml', 'hotelPhone']
}

const TEMPLATE_SECTION_PROPERTY_OVERRIDES = {
  resortDiscovery: RESORT_DISCOVERY_SECTION_PROPERTIES,
  editorialEvent: EDITORIAL_EVENT_SECTION_PROPERTIES
}

const TEMPLATE_SECTION_NAME_OVERRIDES = {
  resortDiscovery: {
    lifestyle: 'Discover image',
    discoverIntro: 'Discover intro',
    discoverButtons: 'Discover buttons',
    gallery: 'Photo gallery'
  },
  editorialEvent: {
    col1: 'Experience 1',
    col2: 'Experience 2',
    col3: 'Experience 3',
    experiencesIntro: 'Experiences heading'
  }
}

const TEMPLATE_PROPERTY_NAME_OVERRIDES = {
  resortDiscovery: {
    galleryTitle: 'Section heading',
    discoverIntroText: 'Section intro text'
  },
  editorialEvent: {
    featuresSectionTitle: 'Section heading',
    col1Html: 'Story content',
    col2Html: 'Story content',
    col3Html: 'Story content',
    col1LinkText: 'Button text',
    col2LinkText: 'Button text',
    col3LinkText: 'Button text',
    col1LinkUrl: 'Button URL',
    col2LinkUrl: 'Button URL',
    col3LinkUrl: 'Button URL',
    col1Image: 'Story image',
    col2Image: 'Story image',
    col3Image: 'Story image',
    ctaBackgroundColor: 'Button border color',
    ctaTextColor: 'Button text color',
    finePrintHtml: 'Footer legal text'
  }
}

export function getTemplateSectionProperties(templateKey, sectionKey) {
  const override = TEMPLATE_SECTION_PROPERTY_OVERRIDES[templateKey]?.[sectionKey]

  if (override) {
    return override
  }

  return sectionsToProperties[sectionKey] || []
}

export function getTemplateSectionLabel(templateKey, sectionKey) {
  return (
    TEMPLATE_SECTION_NAME_OVERRIDES[templateKey]?.[sectionKey] ||
    editableSectionNames[sectionKey] ||
    sectionKey
  )
}

export function getTemplatePropertyLabel(templateKey, propertyKey) {
  return (
    TEMPLATE_PROPERTY_NAME_OVERRIDES[templateKey]?.[propertyKey] ||
    propertyNames[propertyKey] ||
    propertyKey
  )
}

export default getTemplateSectionProperties
